/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_mailbox",
                type: "address",
            },
            {
                internalType: "address",
                name: "_lZEndpoint",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "HookSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "IsmSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "dstChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "address",
                        name: "userApplication",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "refundAddress",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "destination",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "adapterParam",
                        type: "bytes",
                    },
                ],
                internalType: "struct LayerZeroMetadata",
                name: "layerZeroMetadata",
                type: "tuple",
            },
        ],
        name: "formatLzMetadata",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "hook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "hookType",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "interchainSecurityModule",
        outputs: [
            {
                internalType: "contract IInterchainSecurityModule",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lZEndpoint",
        outputs: [
            {
                internalType: "contract ILayerZeroEndpoint",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "localDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mailbox",
        outputs: [
            {
                internalType: "contract IMailbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "lZMetadata",
                type: "bytes",
            },
        ],
        name: "parseLzMetadata",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint16",
                        name: "dstChainId",
                        type: "uint16",
                    },
                    {
                        internalType: "address",
                        name: "userApplication",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "refundAddress",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "payload",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "destination",
                        type: "bytes",
                    },
                    {
                        internalType: "bytes",
                        name: "adapterParam",
                        type: "bytes",
                    },
                ],
                internalType: "struct LayerZeroMetadata",
                name: "parsedLayerZeroMetadata",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "postDispatch",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "message",
                type: "bytes",
            },
        ],
        name: "quoteDispatch",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "setHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "setInterchainSecurityModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
        ],
        name: "supportsMetadata",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class LayerZeroV1Hook__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_mailbox, _lZEndpoint, overrides) {
        return super.deploy(_mailbox, _lZEndpoint, overrides || {});
    }
    getDeployTransaction(_mailbox, _lZEndpoint, overrides) {
        return super.getDeployTransaction(_mailbox, _lZEndpoint, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=LayerZeroV1Hook__factory.js.map